module.exports = __webpack_public_path__ + "static/media/PA-Icon-Vogel-neg.9a9c13b8.svg";